var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-tree-table"},_vm._l((_vm.data.columns),function(column){return _c('column-tree-table-column',{key:column.id,attrs:{"data":column,"layer":_vm.layer,"focus":_vm.focus,"color-map":_vm.colorMap,"data-version":_vm.dataVersion}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }